export default {
  POLE: 10,
  JOINT: 20,
  KP: 50,
  EMERGENCY_TELS: [
    200,
    201,
    203,
    204,
    205,
    206,
    207,
    208,
  ]
}
